module.exports = __webpack_public_path__ + "static/media/431382704_825995689355538_3715689935583580981_n.6f34746c.jpg";